import React, { useState } from "react";
import styled from "styled-components";
import { he } from "date-fns/locale";
import { useTranslation } from "react-i18next";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRange } from "react-date-range";
import theme from "../UI/theme";
import { addMonths } from "date-fns";
import { Button } from "../UI";

const DateRangeStyled = styled(DateRange)(({ theme }) => ({
  "&.rdrCalendarWrapper": {
    fontSize: 15,
    direction: "ltr",
    ".rdrDateDisplayWrapper": {
      backgroundColor: theme.color.white,
      direction: "rtl",
    },
    ".rdrMonths": {
      ".rdrMonth": {
        width: "90vw",
      },
    },
  },
}));

const MobileDateRange = ({ date, setIsDate, handleDateChange }) => {
  const { t } = useTranslation("common");
  // Start from the range that is currently applied, if there is one
  const hasAppliedRange = Array.isArray(date) && !!date[0] && !!date[1];

  const [selectedDate, setSelectedDate] = useState([
    {
      startDate: hasAppliedRange ? new Date(date[0]) : addMonths(new Date(), -1),
      endDate: hasAppliedRange ? new Date(date[1]) : new Date(),
      key: "selection",
    },
  ]);

  return (
    <div
      style={{
        display: "flex",
        backgroundColor: theme.color.white,
        flexDirection: "column",
        flex: 1,
      }}>
      <div
        style={{
          display: "flex",
          backgroundColor: theme.color.white,
          flexDirection: "column",
          alignItems: "center",
          marginTop: 10,
          padding: 10,
          width: "100%",
        }}>
        <DateRangeStyled
          onChange={(item) => setSelectedDate([item.selection])}
          showSelectionPreview={true}
          moveRangeOnFirstSelection={false}
          showMonthAndYearPickers={false}
          months={2}
          ranges={selectedDate}
          direction="vertical"
          locale={he}
          showDateDisplay={true}
        />
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          borderTop: `1px solid #CBCED5`,
          justifyContent: "center",
          width: "100%",
          marginTop: "auto",
          flexDirection: "row-reverse",
          gap: 14,
          padding: 10
        }}>
        <Button buttonStyle="main" onClick={() => setIsDate(false)}>
          {t("common:cancel")}
        </Button>
        <Button
          buttonStyle="border-linear"
          onClick={() => handleDateChange(selectedDate)}>
          {t("common:save")}
        </Button>
      </div>
    </div>
  );
};
export default MobileDateRange;
